/**
 * 埋点集成
 */
import monitor from '@/npm/monitor'
import global from './global'
import { storage } from '../store/local'
import { parseQueryString } from '@/utils/validator'

// 页面链接中加monitorForbid参数 禁止访问埋点
// 例如 提供给大屏使用的协议的页面链接

// 渠道名，获取逻辑如下：
// Step1: 首先从 url 上获取 channel 的值
// Step2: 若无，则从 缓存 中取
// Step3: 若无，兜底 'hy'，指的是杭研渠道
// 应用名，自定义，用于数据区分。格式为：h5-***
const projectName = 'h5-wykj-benefits'

const CHANNEL_KEY_DEF = 'channel'
// const CHANNEL_KJ = '_kj_channel_' // 集运
const CHANNEL_KEY_H5PLATFORM = '_channel_' // h5平台

export const monitorInstall = async () => {
  monitor.install({
    debug: false,
    name: projectName,
    logUrl: `${global.baseURL}/app/tracking_ntrenventtrackingrecord/v1.0.0/add`
  })

  return Promise.resolve()
}

export const monitorOriginal = () => {
  const hashUrl = location.hash
  if (!hashUrl.startsWith('#/entrance/external') && !hashUrl.startsWith('#/entrance/shortChain')) {
    let channel = storage.getChannel()
    let monitorForbid = false

    const search = hashUrl.split('?')[1]
    if (search) {
      const queryFormat = parseQueryString(hashUrl)
      if (queryFormat && queryFormat[CHANNEL_KEY_DEF]) {
        channel = queryFormat[CHANNEL_KEY_DEF]
      }
      if (queryFormat && queryFormat[CHANNEL_KEY_H5PLATFORM]) {
        channel = queryFormat[CHANNEL_KEY_H5PLATFORM]
      }
      if (+queryFormat.monitorForbid === 1) {
        monitorForbid = true
      }
    }
    storage.setChannel(channel)
    monitorInstall().then(() => {
      monitor.click({
        name: 'user_visit_event', // 用户访问事件
        monitorForbid
      }, {
        partnerId: channel
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/monitor.js